import { Dropdown, Menu } from 'antd';
import { Globe } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { Configuration } from '../../constants/configs';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import Updown from '../../assets/icons/Updown.svg';

import { useState } from 'react';

export const Translations = () => {
  const { i18n } = useTranslation();

  const [lan, setLan] = useState<string>(
    localStorage.getItem('i18nextLng') || ENVIRONMENT_CONFIG.DEFAULT_LAN
  );

  const languageMenuItems = Configuration.languages.map((language) => ({
    label: <div className="text-[16px]">{language.label}</div>,
    key: `language/${language.symbol}`,
    onClick: () => {
      if (ENVIRONMENT_CONFIG.DISPLAY_TRANSLATIONS) {
        localStorage.setItem('i18nextLng', language.symbol);
        i18n.changeLanguage(language.symbol);
        setLan(language.symbol);
        return;
      }
      localStorage.setItem('i18nextLng', ENVIRONMENT_CONFIG.DEFAULT_LAN);
    },
  }));

  const menu = (
    <Menu
      className="text-[16px]"
      disabledOverflow={true}
      mode={'vertical'}
      theme={'light'}
      items={languageMenuItems}
    />
  );

  const language = Configuration.languages.find((language) => lan === language.symbol);

  return (
    <Dropdown overlay={menu} trigger={['click']} >
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex cursor-pointer flex-row items-center gap-3 rounded-full border-[1px] !border-default px-3 py-2 text-base !leading-none min-[1024px]:max-[1230px]:!px-2 min-[1024px]:max-[1230px]:!py-1.5 min-[1024px]:max-[1230px]:!text-sm"
      >
        <span className="flex items-center gap-2">
          <Globe /> {language?.label}
        </span>
        <img src={Updown} className="pr-3" />
      </div>
    </Dropdown>
  );
};
